export default __webpack_public_path__ + "static/media/hyundai.cdd07627.svg";